import { useEffect, useState } from 'react';
import styles from './components/ParticipantsModal/ParticipantsModal.module.css';
import { sendInviteMessage, video_room_participants } from '../../Services/Service';
import RadioGroupComponent from '../components/RadioGroupComponent';
import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

import ModelComponent from './../components/ModelComponent';
export default ({ open, onClose, data }) => {

    if (!open) {
        return <></>;
    }
    useEffect(() => {
        if (data.id) {
            handlePaticipent();
        }
        return;
    }, [data.id])

    const [participantsList, setSelectedSessionParticipants] = useState([]);
    const [loading, setParticipantsLoading] = useState(false);
    const [inviteLoading, setinviteLoading] = useState(false);
    const [smsType, setSmsType] = useState('all');
    const handlePaticipent = async () => {
        try {
            setParticipantsLoading(true);
            // First show existing participants from session data
            setSelectedSessionParticipants(data?.participantsList || []);

            // Then fetch updated participants from API
            const response = await video_room_participants(data.id);

            if (response.data.code === 200) { // Changed this line
                const apiParticipants = (response.data.data.videoCallParticipants || []).filter((i) => i.type != 'host');
                console.log(apiParticipants);
                setSelectedSessionParticipants((p) => apiParticipants);
            }
        } catch (error) {
            console.error('Error fetching participants:', error);
            // Keep existing participants if API fails
        } finally {
            setParticipantsLoading(false);
        }
    };
    const [selected, setSelect] = useState([]);
    const length = participantsList.filter((participant) => !(participant.type == 'participant' || participant.userId == 0)).length;

    const handleCheckAll = (e) => {
        (length != 0 && length != selected.length) ?
            setSelect(participantsList.filter((participant) => !(participant.type == 'participant' || participant.userId == 0)).map((i) => i.userId)) :
            setSelect([])
    }

    const sendInvite = async (ids) => {
        console.log(ids);
        if (inviteLoading) {
            return;
        }
        let _ids = encodeURIComponent(JSON.stringify(ids));
        setinviteLoading(true);
        try {
            const response = await sendInviteMessage(data.id, _ids, smsType);
            if (response.status == 200) {
                if (response.data.code == 200) {
                    toast.success(response.data.data.message);
                } else {
                    toast.error(response.data.data.message);
                }
            } else {
                toast.error("Internal server error");
            }

        } catch (e) {
            toast.error(e.message);
        } finally {
            setinviteLoading(false);
        }
    }
    function prettyDate(str) {
        // 1️⃣ parse "dd/MM/yyyy HH:mm"
        const [d, m, y, hh, mm] = str.match(/\d+/g).map(Number);
        const date = new Date(y, m - 1, d, hh, mm);

        // 2️⃣ build ordinal suffix (st / nd / rd / th)
        const ordinal = (n) => {
            const s = ["th", "st", "nd", "rd"];
            const v = n % 100;
            return s[(v - 20) % 10] || s[v] || s[0];
        };

        // 3️⃣ pieces
        const day = d + ordinal(d);                          // 17th
        const month = date.toLocaleString("en-GB", { month: "long" }); // July
        const h12 = date.getHours() % 12 || 12;              // 10
        const mins = String(date.getMinutes()).padStart(2, "0"); // 19
        const ampm = date.getHours() >= 12 ? "PM" : "AM";     // PM

        return `${day} ${month} at ${h12}:${mins}${ampm}`;
    }
    return (

        <>
            <ModelComponent
                isOpen={true}
                onClose={() =>
                    onClose && onClose()}
                heading="Invited List"
            >
                {
                    loading ?
                        <div className={styles.loadingContainer}>
                            <div className={styles.loadingSpinner}></div>
                            <p>Loading participants... </p>
                        </div>
                        : <>

                            <div style={{
                                maxHeight: '45vh',
                                overflow: 'auto'
                            }}>
                                <div >

                                    <table className={styles.table}>
                                        <thead>
                                            <tr>
                                                <th><input style={{
                                                    height: "20px",
                                                    width: "20px"
                                                }} checked={(length != 0 && length == selected.length)}
                                                    disabled={data.isStart}
                                                    onChange={handleCheckAll} type='checkbox' /></th>
                                                <th>Participant Name</th>
                                                <th>Mobile Number</th>
                                                <th>Status</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                participantsList.map((participant) => (
                                                    <tr key={`participent_${participant.id}`}>
                                                        <td>
                                                            <input
                                                                style={{
                                                                    height: "20px",
                                                                    width: "20px"
                                                                }}
                                                                disabled={(participant.type == 'participant' || participant.userId == 0 || data.isStart)}
                                                                type="checkbox"
                                                                checked={selected.includes(participant.userId)}
                                                                onChange={e => {
                                                                    const { checked } = e.target;          // true when box is ticked
                                                                    setSelect(prev =>
                                                                        checked
                                                                            ? prev.includes(participant.userId)    // add only if not already present
                                                                                ? prev
                                                                                : [...prev, participant.userId]
                                                                            : prev.filter(id => id !== participant.userId) // remove when unticked
                                                                    );
                                                                }}
                                                            />

                                                        </td>
                                                        <td>{participant.name}</td>
                                                        <td>{participant.mobileNo}</td>
                                                        <td>
                                                            {
                                                                participant.userId == 0 ?
                                                                    <span title='You can only invite registered patients. Please create account first to enable services.' className={`${styles.typeBadge}`} style={{ width: 60, backgroundColor: 'rgb(238 207 204)', color: '#F44336' }}>
                                                                        Patient not registered
                                                                    </span>
                                                                    :
                                                                    participant.type == '' ?
                                                                        <span className={`${styles.typeBadge}`} style={{ width: 60, backgroundColor: 'rgb(190 190 190 / 36%)', color: 'rgb(130 130 130)' }}>
                                                                            {participant.type == '' && 'Invited'}
                                                                        </span> :
                                                                        <span className={`${styles.typeBadge} ${styles[participant.type]} `}>
                                                                            {participant.type}
                                                                        </span>
                                                            }
                                                        </td>
                                                        <td>
                                                            <button
                                                                className={`${styles.editBtn} ${(participant.userId == 0 || participant.type != '' || inviteLoading || data.isStart)?'':'bg-primary text-white rounded'} `}
                                                                title={`Resend`}
                                                                disabled={(participant.userId == 0 || participant.type != '' || inviteLoading || data.isStart)}
                                                                onClick={() => sendInvite([participant.userId])}
                                                            >
                                                                Resend
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                        </tbody>
                                    </table>
                                </div>

                                <div className={styles.addSection}>
                                    <p>Showing {participantsList.length} of {participantsList.length} entries</p>




                                    <label>Preview Message:</label>
                                    <div className={styles.addContainer}>

                                        <textarea disabled rows={6} className='form-input w-full border p-4'>
                                            {`Hello Jon Doe,
You’ve been invited to a video session with a doctor scheduled for ${prettyDate(data.scheduledDate)} as part of your care plan.
Please confirm your attendance from the GOQii App by clicking the button below.
Need help? Email us at m85178.modalitylifestyles@nhs.net Thank you,
GOQii & NLT Team`}
                                        </textarea>

                                    </div>
                                </div>

                            </div>
                            <div className={styles.addSection}>

                                <RadioGroupComponent
                                    defaultSelected="all"
                                    options={[
                                        { value: 'all', label: 'ALL' },
                                        { value: 'sms', label: 'SMS' },
                                        { value: 'whatsapp', label: 'WhatsApp' },
                                        // { value: 'email', label: 'Email' }
                                    ]}
                                    onChange={(val) => {
                                        setSmsType(val);
                                    }}
                                />

                                <div className='mt-2'>
                                    <button
                                        className={styles.addBtn}
                                        disabled={inviteLoading || selected.length == 0 || data.isStart}
                                        onClick={() => sendInvite(selected)}
                                    >
                                        Invite {selected.length != 0 && selected.length}  patients
                                    </button>
                                </div>
                            </div>
                        </>
                }
            </ModelComponent>

            {/* <div className={styles.modalOverlay}>
            <div className={styles.modalContainer}>
                <div className={styles.modalHeader}>
                    <h2>Invited List</h2>
                    <button className={styles.closeBtn} onClick={() => onClose && onClose()}>
                        <i className="bi bi-x-lg"></i>
                    </button>
                </div>
                {
                    loading ?
                        <div className={styles.loadingContainer}>
                            <div className={styles.loadingSpinner}></div>
                            <p>Loading participants... </p>
                        </div>
                        : <>

                            <div style={{
                                    maxHeight: '45vh',
                                    overflow: 'auto'
                                }}>
                                <div >

                                    <table className={styles.table}>
                                        <thead>
                                            <tr>
                                                <th><input style={{
                                                    height: "20px",
                                                    width: "20px"
                                                }} checked={(length != 0 && length == selected.length)}
                                                    disabled={data.isStart}
                                                    onChange={handleCheckAll} type='checkbox' /></th>
                                                <th>Participant Name</th>
                                                <th>Mobile Number</th>
                                                <th>Status</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                participantsList.map((participant) => (
                                                    <tr key={`participent_${participant.id}`}>
                                                        <td>
                                                            <input
                                                                style={{
                                                                    height: "20px",
                                                                    width: "20px"
                                                                }}
                                                                disabled={(participant.type == 'participant' || participant.userId == 0 || data.isStart)}
                                                                type="checkbox"
                                                                checked={selected.includes(participant.userId)}
                                                                onChange={e => {
                                                                    const { checked } = e.target;          // true when box is ticked
                                                                    setSelect(prev =>
                                                                        checked
                                                                            ? prev.includes(participant.userId)    // add only if not already present
                                                                                ? prev
                                                                                : [...prev, participant.userId]
                                                                            : prev.filter(id => id !== participant.userId) // remove when unticked
                                                                    );
                                                                }}
                                                            />

                                                        </td>
                                                        <td>{participant.name}</td>
                                                        <td>{participant.mobileNo}</td>
                                                        <td>
                                                            {
                                                                participant.userId == 0 ?
                                                                    <span className={`${styles.typeBadge}`} style={{ width: 60, backgroundColor: 'rgb(238 207 204)', color: '#F44336' }}>
                                                                        Patient not registered
                                                                    </span>
                                                                    :
                                                                    participant.type == '' ?
                                                                        <span className={`${styles.typeBadge}`} style={{ width: 60, backgroundColor: 'rgb(190 190 190 / 36%)', color: 'rgb(130 130 130)' }}>
                                                                            {participant.type == '' && 'Invited'}
                                                                        </span> :
                                                                        <span className={`${styles.typeBadge} ${styles[participant.type]} `}>
                                                                            {participant.type}
                                                                        </span>
                                                            }
                                                        </td>
                                                        <td>
                                                            <button
                                                                className={`${styles.editBtn} `}
                                                                title="Cannot delete host"
                                                                disabled={(participant.userId == 0 || participant.type != '' || inviteLoading || data.isStart)}
                                                                onClick={() => sendInvite([participant.userId])}
                                                            >
                                                                Resend
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                        </tbody>
                                    </table>
                                </div>

                                <div className={styles.addSection}>
                                    <p>Showing {participantsList.length} of {participantsList.length} entries</p>

                                


                                    <label>Preview message:</label>
                                    <div className={styles.addContainer}>

                                        <textarea disabled rows={6} className='form-input w-full border p-4'>
                                            {`Hello Jon Doe,
You’ve been invited to a video session with a doctor scheduled for ${prettyDate(data.scheduledDate)} as part of your care plan.
Please confirm your attendance from the GOQii App by clicking the button below.
Need help? Email us at m85178.modalitylifestyles@nhs.net Thank you,
GOQii & NLT Team`}
                                        </textarea>

                                    </div>                                
                                </div>

                            </div>
                            <div className={styles.addSection}>
                                   
                                    <RadioGroupComponent
                                        defaultSelected="all"
                                        options={[
                                            { value: 'all', label: 'ALL' },
                                            { value: 'sms', label: 'SMS' },
                                            { value: 'whatsapp', label: 'WhatsApp' },
                                            // { value: 'email', label: 'Email' }
                                        ]}
                                        onChange={(val) => {
                                            setSmsType(val);
                                        }}
                                    />

                                    <div className='mt-2'>
                                        <button
                                            className={styles.addBtn}
                                            disabled={inviteLoading || selected.length == 0 || data.isStart}
                                            onClick={() => sendInvite(selected)}
                                        >
                                            Invite {selected.length != 0 && selected.length}  patients
                                        </button>
                                    </div>
                                </div>
                        </>
                }
            </div>
        </div> */}
        </>
    );
}